const averageVerbiage = () => {
    return (
        <div>
            <p>
                We estimate the total cost ranges for these services or procedures based on what
                other providers are charging in your zip code. This is the estimated total cost
                before any of your benefits are applied.
            </p>
            <ul>
                <li>Below average means your total cost estimate is below this range.</li>
                <li>Average means your total cost estimate is within this range.</li>
                <li>Above average means your total cost estimate is above this range.</li>
            </ul>
        </div>
    );
};

export { averageVerbiage };
